import React from 'react';
import Timeline from '@mui/lab/Timeline';
import TimelineItem from '@mui/lab/TimelineItem';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import TimelineConnector from '@mui/lab/TimelineConnector';
import CircularProgress from '@mui/material/CircularProgress';
import { GAME_STOPS_CAPTIONS, QUESTIONS_PER_GAME_STOP } from './../../constants.js';

import './GameStopSideBar.scss'


function GameStopSideBar(props) {
  const circularProgressStyle = {
    color: "#B2292D",
    position: "absolute",
    left: 0
  }

  const circularTrailStyle = {
    color: "#E7DCDA",
  }

  const circularFilledStyle = {
    color: "#B2292D",
  }

  return (
    <div className='game-stop-sidebar-container'>
      <Timeline className='game-stop-sidebar-container' position="left" >
        {GAME_STOPS_CAPTIONS.map((_, index) => (
          <TimelineItem key={index}>
            <TimelineSeparator>
              {index + 1 === props.gameStopNumber ?
                <div className="circular-progress">
                  <CircularProgress variant="determinate" thickness={22} value={100} sx={circularTrailStyle} size={20} />
                  <CircularProgress variant="determinate" thickness={22} value={props.currentNumber / QUESTIONS_PER_GAME_STOP * 100} sx={circularProgressStyle} size={20} />
                </div>
                :
                <div>
                  {index + 1 < props.gameStopNumber ?
                    <CircularProgress variant="determinate" thickness={22} value={100} sx={circularFilledStyle} size={20} />
                    :
                    <CircularProgress variant="determinate" thickness={22} value={100} sx={circularTrailStyle} size={20} />
                  }
                </div>
              }
              {index === GAME_STOPS_CAPTIONS.length - 1 ? null : <TimelineConnector />}
            </TimelineSeparator>
          </TimelineItem>
        ))}
      </Timeline>
    </div>
  );
}

export default GameStopSideBar;
